<template>
  <nav class="navbar navbar-expand-lg navbar-dark bg-primary">
    <router-link class="navbar-brand" v-bind:to="{name: 'home'}">Full Stack Authentication</router-link>
  </nav>
</template>

<script>
export default {};
</script>

<style>
</style>